/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";

// import DashboardView from "./views/Dashboard";
import PrivateLayout from "./layouts/Private";
// import DashboardLayout from "./layouts/Dashboard";
import LoginLayout from "./layouts/Login";
import LogoutLayout from "./layouts/Logout";
import RedirectApp from "./layouts/RedirectApp";
import PublicCard from "layouts/PublicCard";

const routes = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/login" />
  },
  {
    path: "/auth/login",
    exact: true,
    component: () => {
      window.location = "/authenticator";
      return null;
    }
  },
  // {
  //   path: "/dispatcher",
  //   exact: true,
  //   component: () => {
  //     window.location = "/dispatcher";
  //     return null;
  //   }
  // },

  {
    path: "/logout",
    component: LogoutLayout,
    routes: [
      {
        path: "/logout",
        exact: true,
        component: lazy(() => import("views/Logout"))
      }
    ]
  },
  {
    path: "/login",
    component: LoginLayout,
    routes: [
      {
        path: "/login",
        exact: true,
        component: lazy(() => import("views/Login"))
      }
    ]
  },
  {
    path: "/newpassword",
    component: LoginLayout,
    routes: [
      {
        path: "/newpassword",
        exact: true,
        component: lazy(() => import("views/NewPassword"))
      }
    ]
  },
  {
    path: "/recoverpassword",
    component: LoginLayout,
    routes: [
      {
        path: "/recoverpassword",
        exact: true,
        component: lazy(() => import("views/RecoverPassword"))
      }
    ]
  },
  {
    path: "/twoSteps",
    component: LoginLayout,
    routes: [
      {
        path: "/twoSteps",
        exact: true,
        component: lazy(() => import("views/TwoSteps"))
      }
    ]
  },
  {
    path: "/redefinirsenha",
    component: PublicCard,
    routes: [
      {
        path: "/redefinirsenha",
        exact: true,
        component: lazy(() => import("views/RedefinirSenha"))
      }
    ]
  },
  // {
  //   path: "/checktoken",
  //   component: LoginLayout,
  //   routes: [
  //     {
  //       path: "/checktoken",
  //       exact: true,
  //       component: lazy(() => import("views/CheckToken"))
  //     }
  //   ]
  // },
  {
    route: "*",
    component: PrivateLayout,
    routes: [
      // {
      //   path: "/dashboards",
      //   exact: true,
      //   component: PrivateLayout,
      // },
      {
        path: "/dashboards",
        exact: true,
        component: lazy(() => import("views/Dashboard"))
      },
      {
        path: "/management/list",
        exact: true,
        component: lazy(() => import("views/UserManagement/List"))
      },
      {
        path: "/management/edit/:id",
        exact: true,
        component: lazy(() => import("views/UserManagement/Edit"))
      },
      //{
      //  path: "/profiles/list",
      //  exact: true,
      //  component: lazy(() => import("views/Profile/List"))
      //},
      // {
      //   path: "/profiles/edit",
      //   exact: true,
      //   component: lazy(() => import("views/Profile/Edit"))
      // },
      // {
      //   path: "/profiles/edit/:id",
      //   exact: true,
      //   component: lazy(() => import("views/Profile/Edit"))
      // },
      // {
      //   path: "/profiles/edit/:id/:clone",
      //   exact: true,
      //   component: lazy(() => import("views/Profile/Edit"))
      // },
      // {
      //   path: "/users/list",
      //   exact: true,
      //   component: lazy(() => import("views/User/List"))
      // },
      // {
      //   path: "/users/edit",
      //   exact: true,
      //   component: lazy(() => import("views/User/Edit"))
      // },
      // {
      //   path: "/users/edit/:id",
      //   exact: true,
      //   component: lazy(() => import("views/User/Edit"))
      // },
      {
        path: "/acesso_negado",
        exact: true,
        component: lazy(() => import("views/ProhibitedAccess"))
      },
      {
        path: "/contrato",
        exact: true,
        component: lazy(() => import("views/Contract"))
      },
      {
        path: "/fatura",
        exact: true,
        component: lazy(() => import("views/Invoice"))
      },
      {
        path: "/pagex",
        exact: true,
        component: lazy(() => import("views/Pagex"))
      },
      {
        path: "/ajuda",
        exact: true,
        component: lazy(() => import("views/Help"))
      },
      {
        path: "/meuperfil",
        exact: true,
        component: lazy(() => import("views/MyProfile"))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];

export default routes;
